import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const MessageableSchema = withDefaults({
  type: 'messageable',
  fields: [
    {
      kind: 'hasMany',
      name: 'messages',
      type: 'message',
      options: {
        async: false,
        inverse: 'messageable',
        as: 'messageable',
      },
    },
  ],
});

export default MessageableSchema;
